export const ACCOUNT_GET_PORTFOLIO_START = 'ACCOUNT_GET_PORTFOLIO_START' as const;
export const ACCOUNT_GET_PORTFOLIO_SUCCESS = 'ACCOUNT_GET_PORTFOLIO_SUCCESS' as const;
export const ACCOUNT_GET_PORTFOLIO_FAILURE = 'ACCOUNT_GET_PORTFOLIO_FAILURE' as const;

export const ACCOUNT_GET_TRADING_TOKEN_START = 'ACCOUNT_GET_TRADING_TOKEN_START' as const;
export const ACCOUNT_GET_TRADING_TOKEN_SUCCESS = 'ACCOUNT_GET_TRADING_TOKEN_SUCCESS' as const;
export const ACCOUNT_GET_TRADING_TOKEN_FAILURE = 'ACCOUNT_GET_TRADING_TOKEN_FAILURE' as const;

export const PAYOUT_TRANSACTIONS_START = 'PAYOUT_TRANSACTIONS_START' as const;
export const PAYOUT_TRANSACTIONS_SUCCESS = 'PAYOUT_TRANSACTIONS_SUCCESS' as const;
export const PAYOUT_TRANSACTIONS_FAILURE = 'PAYOUT_TRANSACTIONS_FAILURE' as const;

export const RESET_ACCOUNT_ERROR = 'RESET_ACCOUNT_ERROR' as const;

export const RESEND_USER_CONFIRM_EMAIL_START = 'RESEND_USER_CONFIRM_EMAIL_START' as const;
export const RESEND_USER_CONFIRM_EMAIL_SUCCESS = 'RESEND_USER_CONFIRM_EMAIL_SUCCESS' as const;
export const RESEND_USER_CONFIRM_EMAIL_FAILURE = 'RESEND_USER_CONFIRM_EMAIL_FAILURE' as const;

export const SET_CONFIRM_EMAIL_REQUEST_TIME = 'SET_CONFIRM_EMAIL_REQUEST_TIME' as const;

export const SET_ACCOUNT_SELECTED_HISTORY_INFO = 'SET_ACCOUNT_SELECTED_HISTORY_INFO' as const;

export const REFILL_DEMO_START = 'REFILL_DEMO_START' as const;
export const REFILL_DEMO_SUCCESS = 'REFILL_DEMO_SUCCESS' as const;
export const REFILL_DEMO_FAILURE = 'REFILL_DEMO_FAILURE' as const;
